import React from "react";
import { siteConfig } from "../../data/mockData";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const ContactInfoSidebar = () => {
  return (
    <>
      <div className="bg-[#F1F8F2] rounded-2xl p-8 mb-6">
        <h3 className="text-lg font-bold text-[#1B2A1B] mb-6">Contact Information</h3>
        <ul className="space-y-5">
          <li className="flex items-start gap-4">
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
              <Phone size={18} className="text-[#3A7D44]" />
            </div>
            <div>
              <p className="text-xs text-[#5A6B5A] mb-1">Phone</p>
              <a
                href={`tel:${siteConfig.phone}`}
                className="text-[#1B2A1B] font-semibold hover:text-[#3A7D44] transition-colors"
              >
                {siteConfig.phoneFormatted}
              </a>
            </div>
          </li>
          <li className="flex items-start gap-4">
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
              <Mail size={18} className="text-[#3A7D44]" />
            </div>
            <div>
              <p className="text-xs text-[#5A6B5A] mb-1">Email</p>
              <a
                href={`mailto:${siteConfig.email}`}
                className="text-[#1B2A1B] font-semibold hover:text-[#3A7D44] transition-colors text-sm"
              >
                {siteConfig.email}
              </a>
            </div>
          </li>
          <li className="flex items-start gap-4">
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
              <MapPin size={18} className="text-[#3A7D44]" />
            </div>
            <div>
              <p className="text-xs text-[#5A6B5A] mb-1">Location</p>
              <p className="text-[#1B2A1B] font-semibold text-sm">
                {siteConfig.address.city}, {siteConfig.address.state}{" "}
                {siteConfig.address.zip}
              </p>
            </div>
          </li>
          <li className="flex items-start gap-4">
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
              <Clock size={18} className="text-[#3A7D44]" />
            </div>
            <div>
              <p className="text-xs text-[#5A6B5A] mb-1">Hours</p>
              <p className="text-[#1B2A1B] font-semibold text-sm">{siteConfig.hours}</p>
            </div>
          </li>
        </ul>
      </div>

      {/* Kim card */}
      <div className="bg-white rounded-2xl border border-gray-100 p-6 flex items-center gap-4">
        <img
          src={siteConfig.kimHeadshot}
          alt="Kimberly Hess"
          className="w-16 h-16 rounded-full object-cover object-top"
        />
        <div>
          <p className="font-bold text-[#1B2A1B]">Kimberly Hess</p>
          <p className="text-sm text-[#5A6B5A]">Licensed Health & Life Insurance Broker</p>
          <p className="text-xs text-[#3A7D44] mt-1">Serving clients in all 50 states</p>
        </div>
      </div>
    </>
  );
};

export default ContactInfoSidebar;
